/* 🤖 this file was generated by svg-to-ts */
export const matIconDone: {
  name: 'done';
  data: string;
} = {
  name: 'done',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/></svg>`
};
